import { render, staticRenderFns } from "./userRoleForm.vue?vue&type=template&id=05d23f2a&"
import script from "./userRoleForm.vue?vue&type=script&lang=js&"
export * from "./userRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports